import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA, PageEvent, MatPaginator } from '@angular/material';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import swal from 'sweetalert2';
import { GlobalService } from '../../services/global.service';
import { FiltroDA } from 'src/app/models/atualizaDA';
import { FuncionarioService } from '../../services/funcionario.service';
import { Filtro } from 'src/app/models/filtro';
import { PaginatorService } from 'src/app/services/paginator.service';

@Component({
  selector: 'app-filtros-gestao-de-descontos',
  templateUrl: './filtros-gestao-de-descontos.component.html',
  styleUrls: ['./filtros-gestao-de-descontos.component.scss']
})
export class FiltrosGestaoDeDescontosComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  idUsuario: number;
  filtros: FiltroDA[] = [];
  filtroSelecionado: FiltroDA = new FiltroDA();
  administrador = false;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  idFiltro;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private funcionarioService: FuncionarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private dialogRef: MatDialogRef<FiltrosGestaoDeDescontosComponent>,
    private paginatorService: PaginatorService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idUsuario = data.idUsuario;
    this.idFiltro = data.idFiltro;
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.administrador = await this.globalService.administrador();

    this.buscarFiltros();
  }

  buscarFiltros() {
    this.carregandoService.mostra('buscaFiltros');
    this.funcionarioService.consultarFiltroComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.idUsuario).subscribe(resp => {
      this.filtros = resp.itens;
      this.paginacao.total = resp.total;

      this.carregandoService.esconde('buscaFiltros');
    }, (erro) => {
      this.carregandoService.esconde('buscaFiltros');
    });
  }

  excluirFiltro(filtro: FiltroDA) {
    swal({
      title: 'Atenção!!',
      text: '"Tem certeza que deseja excluir o filtro?"',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiFiltro');
        this.funcionarioService.excluirFiltros(filtro).subscribe(resp => {
          this.buscarFiltros();
          this.carregandoService.esconde('excluiFiltro');
        }, (erro) => {
          this.notificacaoService.erro('Não foi possível excluir o filtro.');
          this.carregandoService.esconde('excluiFiltro');
        });
      }
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  selecionarFiltro(filtro: FiltroDA) {
    this.dialogRef.close(filtro);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFiltros();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }
}